<template>
  <section>
    <VerReporte />
    <v-card>
      <!-- Cabecera del formulario -->
      <v-card-title class="headline m-0">
        <v-flex xs9>
          <v-icon>today</v-icon>
          Reporte de marcado
        </v-flex>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text>
        <!-- Cuerpo del formulario -->
        <v-form
          @submit.prevent="save"
          v-model="valid"
          ref="form"
          lazy-validation
        >
          <v-card-text class="py-0 px-2">
            <v-container grid-list-md style="min-width: 100%" class="p-0">
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <v-text-field
                    class="text-field-reducido-border"
                    outline
                    type="date"
                    v-model="form.fecha_inicio"
                    label="Fecha inicio"
                    @input="filtraFuncionarios()"
                    :rules="$validate(['required'])"
                    required
                  />
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    class="text-field-reducido-border"
                    outline
                    type="date"
                    v-model="form.fecha_fin"
                    label="Fecha fin"
                    @input="filtraFuncionarios()"
                    :rules="$validate(['required'])"
                    required
                  />
                </v-flex>
                <!-- <v-flex xs12>
                  <v-autocomplete
                    class="text-field-reducido-border"
                    outline
                    :items="unidades_generales"
                    item-value="id_unidad"
                    item-text="nombre_unidad"
                    v-model="form.id_unidad_general"
                   @input="filtraFuncionarios()"
                    label="Unidad general"
                    maxlength="50"
                  />
                </v-flex> -->
                <v-flex xs12>
                  <v-autocomplete
                    class="text-field-reducido-border"
                    outline
                    :items="unidades_especificas"
                    item-value="id_unidad"
                    item-text="nombre_unidad"
                    v-model="form.id_unidad_especifica"
                    @input="filtraFuncionarios()"
                    label="Unidad especifica"
                    maxlength="50"
                  />
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    class="text-field-reducido-border"
                    outline
                    v-model="form.paterno"
                    label="Paterno"
                    @input="filtraFuncionarios()"
                  />
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    class="text-field-reducido-border"
                    outline
                    v-model="form.materno"
                    label="Materno"
                    @input="filtraFuncionarios()"
                  />
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    class="text-field-reducido-border"
                    outline
                    v-model="form.nombres"
                    label="Nombres"
                    @input="filtraFuncionarios()"
                  />
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    class="text-field-reducido-border"
                    outline
                    v-model="form.ci"
                    label="Cédula de identidad"
                    @input="filtraFuncionarios()"
                  />
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    class="text-field-reducido-border"
                    outline
                    v-model="form.item"
                    label="Item"
                    @input="filtraFuncionarios()"
                  />
                </v-flex>
              </v-layout>
              <v-btn
                :disabled="!bandera_boton_buscar"
                color="rgba(31,14,180,0.3)"
                @click="
                  obtenerListaFuncionarios(form.fecha_inicio, form.fecha_fin)
                "
                type="submit"
              >
                <v-icon>search</v-icon>
                Buscar
              </v-btn>
              <v-btn
                color="rgba(158,11,127,0.6)"
                @click="limpiarCampos()"
                type="submit"
              >
                <v-icon>redo</v-icon>
                Limpiar
              </v-btn>
              <v-btn
                :disabled="
                  !bandera_boton_buscar ||
                    (form.paterno != undefined && form.paterno != '') ||
                    (form.materno != undefined && form.materno != '') ||
                    (form.nombres != undefined && form.nombres != '') ||
                    (form.ci != undefined && form.ci != '') ||
                    (form.item != undefined && form.item != '')
                "
                color="rgba(50,150,40,0.7)"
                title="Ver reporte "
                type="submit"
                @click.prevent="verReporte(form, 1)"
              >
                <v-icon>picture_as_pdf</v-icon>
              </v-btn>

              <v-btn
                :disabled="
                  !bandera_boton_buscar ||
                    (form.paterno != undefined && form.paterno != '') ||
                    (form.materno != undefined && form.materno != '') ||
                    (form.nombres != undefined && form.nombres != '') ||
                    (form.ci != undefined && form.ci != '') ||
                    (form.item != undefined && form.item != '')
                "
                color="rgba(50,150,40,0.7)"
                title="Ver reporte (XLS)"
                type="submit"
                @click.prevent="verReporte(form, 3)"
              >
              <v-icon>description</v-icon>
              </v-btn>

            </v-container>
          </v-card-text>
        </v-form>
        <v-data-table
          class="elevation-1"
          :headers="headers"
          :items="lista_filtrada_funcionarios"
          :no-data-text="loading ? 'Cargando...' : 'No se tiene registros'"
          :loading="loading"
          item-key="index"
          rows-per-page-text="Filas por pagina"
          :pagination.sync="pagination"
          :rows-per-page-items="[5, 10, 20, 50, { value: -1, text: 'Todos' }]"
        >
          <template v-slot:headers="props">
            <tr>
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="[
                  'column sortable',
                  pagination.descending ? 'desc' : 'asc',
                  header.value === pagination.sortBy ? 'active' : ''
                ]"
                class="header-comprimido-tabla"
                @click="changeSort(header.value)"
              >
                <v-icon v-if="header.value" small 
                  >arrow_upward</v-icon
                >
                {{ header.text }}
              </th>
            </tr>
          </template>
          <template v-slot:items="props">
            <td class="text-xs-center py-0 px-1">
              <v-avatar
                :color="props.item.foto ? '#FFF' : 'light-blue darken-4'"
              >
                <img
                  v-if="props.item.foto"
                  :src="url_backend + props.item.foto"
                  :alt="props.item.nombres[0]"
                  style="border: 1px solid #7BAFD4 !important;"
                  @error="handleImageError(props.item)"
                />
                <span v-else class="white--text headline">{{
                  props.item.nombres[0] || "-"
                }}</span>
              </v-avatar>
            </td>
            <td class="text-xs-center py-0 px-2">
              {{ props.item.nro_item }}
            </td>
            <td class="text-xs-center py-0 px-2">
              {{ props.item.ap_paterno }} {{ props.item.ap_materno }}
              {{ props.item.nombres }}
            </td>
            <td class="text-xs-center py-0 px-2">
              {{ props.item.nro_doc }}
            </td>
            <td class="text-xs-center py-0 px-2">
              {{ props.item.dependencia }}
            </td>
            <td class="text-xs-center py-0 px-2">
              {{ props.item.nombre_unidad }}
            </td>

            <td class="text-xs-center py-0 px-2">
              <v-btn
                color="#F58736"
                @click.prevent="verReporte(props.item, 2)"
                icon
                title="Ver reporte de asistencia del funcionario"
              >
                <v-icon>picture_as_pdf</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import validate from "@/common/mixins/validate";
import crud from "@/common/util/crud-table/mixins/crud-table"; // Funciones y Metodos
import VerReporte from "./dialogs/VerReporte";

export default {
  // Importación de métodos y funciones de un archivo mixin
  mixins: [],
  // Variables iniciales del componente
  mixins: [validate, crud],
  data() {
    return {
      pagination: {
        sortBy: ""
      },
      form: {},
      valid: false,
      loading: false,
      validated: 0,
      bandera_boton_buscar: true,
      url_backend: process.env.API_URL.split("api/")[0],
      headers: [
        {
          text: "",
          value: "",
          align: "center"
        },
        {
          text: "Item",
          value: "nro_item",
          align: "center"
        },
        {
          text: "Nombre completo",
          value: "nombres",
          align: "center"
        },
        {
          text: "Cédula de identidad",
          value: "ap_paterno",
          align: "center"
        },

        {
          text: "Unidad general",
          value: "dependencia",
          align: "center"
        },
        {
          text: "Unidad específica",
          value: "nombre_unidad",
          align: "center"
        },
        { text: this.$t("common.actions"), sortable: false }
      ],
      unidades_generales: [],
      unidades_especificas: [],
      lista_funcionarios: [],
      lista_filtrada_funcionarios: []
    };
  },
  // Funcionalidades que se ejecutan al montar el componente
  async mounted() {
    // Verificando si el usuario tiene permiso para interactual con el componente
    const rolesPermitidos = [0]; // ID's de roles permitidos
    if (!this.$util.permisoRol(rolesPermitidos)) {
      this.$router.push("/403");
    }
    await this.cargarListaUnidadesGenerales();
    await this.cargarListaUnidadesEspecificas();
    var date = new Date();
    let primer_dia_mes = new Date(date.getFullYear(), date.getMonth(), 1);
    primer_dia_mes = this.$moment(primer_dia_mes).format("YYYY-MM-DD");
    let ultimo_dia_año = this.$moment().format("YYYY-MM-DD");
    this.form.id_unidad_general = 0;
    this.form.id_unidad_especifica = 0;
    this.form.materno = "";
    this.form.paterno = "";
    this.form.nombres = "";
    this.form.ci = "";
    this.form.item = "";
    this.form.fecha_inicio = primer_dia_mes;
    this.form.fecha_fin = ultimo_dia_año;
    this.bandera_boton_buscar = true;
    await this.obtenerListaFuncionarios(primer_dia_mes, ultimo_dia_año);
  },
  // Métodos y funciones del componente
  methods: {
    // Metodo para ordenar la tabla
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    // Metodo para verificar si ocurrio un error al cargar la imagen
    handleImageError(item) {
      item.foto = "";
    },
    // Metodo que filtra la lista de funcionarios
    filtraFuncionarios() {
      if (!this.form.id_unidad_especifica) {
        this.form.id_unidad_especifica = "";
      }
      if (!this.form.materno) {
        this.form.materno = "";
      }
      if (!this.form.paterno) {
        this.form.paterno = "";
      }
      if (!this.form.nombres) {
        this.form.nombres = "";
      }
      if (!this.form.ci) {
        this.form.ci = "";
      }
      if (!this.form.item) {
        this.form.item = "";
      }
      this.lista_filtrada_funcionarios = this.lista_funcionarios.filter(
        persona =>
          (persona.ap_paterno ? persona.ap_paterno : "")
            .toUpperCase()
            .indexOf(this.form.paterno.toUpperCase()) != -1 &&
          (persona.ap_materno ? persona.ap_materno : "")
            .toUpperCase()
            .indexOf(this.form.materno.toUpperCase()) != -1 &&
          (persona.nombres ? persona.nombres : "")
            .toUpperCase()
            .indexOf(this.form.nombres.toUpperCase()) != -1 &&
          (persona.nro_item ? persona.nro_item : "")
            .toUpperCase()
            .indexOf(this.form.item.toUpperCase()) != -1 &&
          (persona.nro_doc ? persona.nro_doc : "")
            .toUpperCase()
            .indexOf(this.form.ci.toUpperCase()) != -1 &&
          (persona.id_unidad ? persona.id_unidad + "" : "")
            .toUpperCase()
            .indexOf(this.form.id_unidad_especifica.toString().toUpperCase()) !=
            -1
      );
    },
    async obtenerListaFuncionarios() {
      this.loading = true;
      try {
        this.bandera_boton_buscar = true;
        if (this.form.fecha_inicio && this.form.fecha_fin) {
          this.lista_funcionarios = [];
          var query = `select * from planilla.fn_lista_funcionarios_tipificacion('${this.form.fecha_inicio}','${this.form.fecha_fin}') as (id_persona integer,ap_paterno varchar,ap_materno varchar,nombres varchar, nro_doc varchar,nro_complemento varchar, nro_item varchar, dependencia varchar, foto varchar,id_tipo_justificacion integer,fecha_incorporacion date,fecha_retiro date, id_unidad integer,nombre_unidad varchar)`;
          let res = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta:"${query}"){
                  respuesta
                }
              }
            `
          });
          if (res.runQuery.respuesta.length != 0) {
            this.lista_funcionarios = res.runQuery.respuesta;
            this.filtraFuncionarios();
          }
        } else {
          this.bandera_boton_buscar = false;
        }
      } catch (error) {
        console.log(error);
      }
      this.loading = false;
    },
    limpiarCampos() {
      try {
        this.form = {};
        this.bandera_boton_buscar = false;
      } catch (error) {
        console.log(error);
      }
    },
    async cargarListaUnidadesGenerales() {
      try {
        let res = await this.$service.graphql({
          query: `
              query{
                vUnidadesGeneraless(lista_niveles:"0,1"){
                  rows{
                    id_unidad
                    nombre_unidad
                    nivel
                  }
                }
              }
          `
        });
        this.unidades_generales = res.vUnidadesGeneraless.rows;
      } catch (error) {
        console.log(error);
      }
    },
    verReporte(item, valor) {
      let url;
      let nombre_reporte = "";
      let formato_doc = "output=pdf";
      let nombre_carpeta = "marcados";
      let url_carpeta = process.env.REPORTE_URL_OFICIAL.replace(
        /{carpeta}/g,
        nombre_carpeta
      );
      let url_parametros = null;
      if (valor == 1) {
        //reporte generales de asistencia
        if (!item.id_unidad_general) {
          item.id_unidad_general = 0;
        }
        if (!item.id_unidad_especifica) {
          item.id_unidad_especifica = 0;
        }
        if (!item.materno) {
          item.materno = "";
        }
        if (!item.paterno) {
          item.paterno = "";
        }
        if (!item.nombres) {
          item.nombres = "";
        }
        if (!item.ci) {
          item.ci = "";
        }
        if (!item.item) {
          item.item = "";
        }
        if (!item.id_cargo) {
          item.id_cargo = 0;
        }
        nombre_reporte = "rpt_asistencia_general_marcados";
      } else if(valor == 3) 
      {
        formato_doc = "output=xls";
        //reporte generales de asistencia
        if (!item.id_unidad_general) {
          item.id_unidad_general = 0;
        }
        if (!item.id_unidad_especifica) {
          item.id_unidad_especifica = 0;
        }
        if (!item.materno) {
          item.materno = "";
        }
        if (!item.paterno) {
          item.paterno = "";
        }
        if (!item.nombres) {
          item.nombres = "";
        }
        if (!item.ci) {
          item.ci = "";
        }
        if (!item.item) {
          item.item = "";
        }
        if (!item.id_cargo) {
          item.id_cargo = 0;
        }
        nombre_reporte = "rpt_asistencia_general_marcados_xls";
      }
      else {
        //reporte de aistencias por funcionario
        nombre_reporte = "rpt_asistencia_general2";
      }






      url = `${url_carpeta}${nombre_reporte}&${formato_doc}`;
      console.log('url reporte planilla...   ',url);
      //Parametros
      let id_permiso = this.form.id_permiso;




      // URL con parametros
      if (valor == 1 || valor == 3) {
        //reporte generales de asistencia

        //this.form.fecha_inicio = this.$moment(this.form.fecha_inicio).format(
          //"DD/MM/YYYY"
        //);

        url_parametros = `${url}&fecha_inicio=${
          this.$moment(this.form.fecha_inicio).format(
          "MM/DD/YYYY"
        )
        }&fecha_fin=${this.$moment(this.form.fecha_fin).format(
          "MM/DD/YYYY"
        )}&p_unidad_general=${item.id_unidad_general}&p_paterno=${
          item.paterno
        }&p_materno${item.materno}=&p_nombres=${item.nombres}&p_ci=${
          item.ci
        }&p_item=${item.item}&p_unidad_especifica=${item.id_unidad_especifica}`;
      } else {
        //reporte  de asistencia por funcionario

        //var f_inicio = this.$moment(this.form.fecha_inicio).format("YYYY-MM-DD");
        //var f_fin = this.$moment(this.form.fecha_fin).format("YYYY-MM-DD");
        url_parametros = `${url}&fecha_inicio=${this.$moment(this.form.fecha_inicio).format("YYYY-MM-DD")}&fecha_fin=${this.$moment(this.form.fecha_fin).format("YYYY-MM-DD")}&id_persona=${item.id_persona}`;
      }

      console.log(url_parametros);
      this.$bus.$emit("openDialogVerReporte", url_parametros);
    },
    async cargarListaUnidadesEspecificas() {
      try {
        let res = await this.$service.graphql({
          query: `
              query{
                vUnidadesGeneraless{
                  rows{
                    id_unidad
                    nombre_unidad
                    nivel
                  }
                }
              }
          `
        });
        this.unidades_especificas = res.vUnidadesGeneraless.rows;
      } catch (error) {
        console.log(error);
      }
    },
    save() {
      try {
      } catch (error) {}
    }
  },
  // Definición de componentes importados
  components: {
    VerReporte
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/asistencia/Index.vue